import "../../assets/css/loader.css";

const Loader = ({ message = "Loading..." }) => {
    return (
        <div className="loader-container">
            <div className="loader-spinner"></div>
            <p>{message}</p>
        </div>
    );
};

export default Loader;